// src/api/founding.ts
// Public-facing helpers for the founding-member recruiting section.

import { supabase } from './supabase'
import type { Database } from '@/types/database.types'

const FOUNDING_LIMIT = 5

export type ServiceType = Database['public']['Enums']['workspace_kind']

export interface FoundingSlots {
  serviceType: ServiceType
  total: number
  filled: number
  remaining: number
  full: boolean
}

/**
 * Returns founding-cohort capacity for a single service type.
 * Counts via head request — no row data leaks (RLS allows reading
 * is_public + status, and these counts are public marketing info anyway).
 */
export async function getFoundingSlots(
  serviceType: ServiceType,
): Promise<FoundingSlots> {
  const { count, error } = await supabase
    .from('vendor_workspaces')
    .select('id', { count: 'exact', head: true })
    .eq('service_type', serviceType)
    .eq('founding_member', true)

  if (error) throw error
  const filled = count ?? 0
  const remaining = Math.max(0, FOUNDING_LIMIT - filled)
  return {
    serviceType,
    total: FOUNDING_LIMIT,
    filled,
    remaining,
    full: remaining === 0,
  }
}
